import { friendlyUrlGenerator } from '@/packages/vue-friendly'
import { createReceiver, baseResource as baseSimpleResource, createSender, createUpdater } from '@/plugins/resource'
import { urlConstructor, prefixAPI } from '@/plugins/resource/api'

const MODEL = 'services'
const MODEL_ADMIN = MODEL + '/admin'
const MODEL_ADMIN_GROUP = MODEL_ADMIN + '/group'
const MODEL_ADMIN_IMPORT = MODEL_ADMIN + '/import'

export const SERVICES_DELIVERY_MODE_LIST_URL = urlConstructor(
  MODEL + '/delivery-mode/list/',
  []
)
export const SERVICES_EXPORT_FILES_URL = urlConstructor(
  MODEL + '/export-files/',
  []
)
export const SERVICES_DOCTOR_LIST_URL = prefixAPI('/for_doctor/list/', MODEL)
export const SERVICES_MEDICAL_FACILITY_LIST_URL = prefixAPI('/for_medical/list/', MODEL)
export const SERVICES_CLASSIFIERS_ROOT_LIST_URL = urlConstructor(MODEL + '/classifiers/root-list/', [])
export const SERVICES_CLASSIFIERS_CHILDREN_LIST_URL = urlConstructor(MODEL + '/classifiers/children-list{/classifier_id}/', [])
export const SERVICES_LIST_URL = urlConstructor(MODEL + '/list/', [
  'ids',
  'search',
])
export const SERVICES_DETAIL_URL = urlConstructor(MODEL + '/detail/{id}/', [])

// admins urls
export const SERVICES_ADMIN_CREATE_URL = urlConstructor(MODEL_ADMIN + '/create/', [])
export const SERVICES_ADMIN_DETAIL_URL = urlConstructor(MODEL_ADMIN + '/detail{/id}/', [])
export const SERVICES_ADMIN_FILTER_LIST_URL = urlConstructor(MODEL_ADMIN + '/filter-list/', [])
export const SERVICES_ADMIN_LIST_URL = urlConstructor(MODEL_ADMIN + '/list/', ['filters'])
export const SERVICES_ADMIN_UPDATE_URL = urlConstructor(MODEL_ADMIN + '/update{/id}/', [])
export const SERVICES_ADMIN_GROUP_CREATE_URL = urlConstructor(MODEL_ADMIN_GROUP + '/create/', [])
export const SERVICES_ADMIN_GROUP_DELETE_URL = urlConstructor(MODEL_ADMIN_GROUP + '/delete/', [])
export const SERVICES_ADMIN_GROUP_LIST_URL = urlConstructor(MODEL_ADMIN_GROUP + '/list/', [])
export const SERVICES_ADMIN_GROUP_REORDER_URL = urlConstructor(MODEL_ADMIN_GROUP + '/reorder/', [])
export const SERVICES_ADMIN_GROUP_UPDATE_URL = urlConstructor(MODEL_ADMIN_GROUP + '/update{/id}/', [])
export const SERVICES_ADMIN_IMPORT_CANCELED_URL = urlConstructor(MODEL_ADMIN_IMPORT + '/canceled/', [])
export const SERVICES_ADMIN_IMPORT_CREATE_URL = urlConstructor(MODEL_ADMIN_IMPORT + '/create/', [])
export const SERVICES_ADMIN_IMPORT_LIST_URL = urlConstructor(MODEL_ADMIN_IMPORT + '/list/', [])
export const SERVICES_ADMIN_IMPORT_PRE_IMPORT_URL = urlConstructor(MODEL_ADMIN_IMPORT + '/pre-import/', [])

export const servicesDetailResource = createReceiver(SERVICES_DETAIL_URL)
export const servicesExportFilesResource = createReceiver(SERVICES_EXPORT_FILES_URL)
export const servicesDeliveryModesResource = createReceiver(SERVICES_DELIVERY_MODE_LIST_URL)

export const doctorServicesResource = friendlyUrlGenerator([
  SERVICES_DOCTOR_LIST_URL, 'filters/'
], baseSimpleResource)
export const medicalFacilityServicesResource = friendlyUrlGenerator([
  SERVICES_MEDICAL_FACILITY_LIST_URL, 'filters/'
], baseSimpleResource)


// admins resources
export const servicesAdminCreateResource = createSender(SERVICES_ADMIN_CREATE_URL)
export const servicesAdminDetailResource = createReceiver(SERVICES_ADMIN_DETAIL_URL)
export const servicesAdminFilterListResource = createReceiver(SERVICES_ADMIN_FILTER_LIST_URL)
export const servicesAdminListResource = createReceiver(SERVICES_ADMIN_LIST_URL)
export const servicesAdminUpdateResource = createUpdater(SERVICES_ADMIN_UPDATE_URL)
export const servicesAdminGroupCreateResource = createSender(SERVICES_ADMIN_GROUP_CREATE_URL)
export const servicesAdminGroupDeleteResource = createSender(SERVICES_ADMIN_GROUP_DELETE_URL)
export const servicesAdminGroupListResource = createReceiver(SERVICES_ADMIN_GROUP_LIST_URL)
export const servicesAdminGroupReorderResource = createSender(SERVICES_ADMIN_GROUP_REORDER_URL)
export const servicesAdminGroupUpdateResource = createUpdater(SERVICES_ADMIN_GROUP_UPDATE_URL)

export const servicesAdminImportCanceledRecource = createSender(SERVICES_ADMIN_IMPORT_CANCELED_URL)
export const servicesAdminImportCreateRecource = createSender(SERVICES_ADMIN_IMPORT_CREATE_URL)
export const servicesAdminImportListRecource = createReceiver(SERVICES_ADMIN_IMPORT_LIST_URL)
export const servicesAdminImportPreImportRecource = createSender(SERVICES_ADMIN_IMPORT_PRE_IMPORT_URL)